import { SepiaVariantProps } from 'common/Prose/nodeViews/Image/components/ImageVariant/Types'
import { ImageVariant } from 'common/Prose/nodeViews/Image/components/ImageVariant/ImageVariant'
import { Text } from 'blaze-ui/Text/Text'
import { Slider } from 'almanac-ui/Slider/Slider'
import { useImageStore } from 'stores/ImageStore'
import { useCloudinary } from 'providers/CloudinaryProvider/CloudinaryProvider'
import { useId } from '@react-aria/utils'
import { useState } from 'react'
import { sepia } from '@cloudinary/url-gen/actions/effect'

export const SepiaVariant = (props: SepiaVariantProps) => {
  const { variant } = props
  const imageStore = useImageStore()
  const cloudinary = useCloudinary()
  const id = useId()
  const [localValue, setLocalValue] = useState(variant.qualifier || 80)

  if (!cloudinary) return null

  return (
    <ImageVariant {...props}>
      <Text variant="label" id={id}>
        Change sepia
      </Text>
      <Slider
        aria-labelledby={id}
        minValue={1}
        maxValue={100}
        step={1}
        onChange={(value) => setLocalValue(value as number)}
        value={localValue}
        onChangeEnd={(value) => {
          const image = cloudinary.image(variant.sourceUrl.split('?')[0]).setDeliveryType('fetch')
          image.effect(sepia(value as number))
          imageStore.clearVariants()
          imageStore.createVariant({ image, url: image.toURL(), action: 'sepia', qualifier: value as number })
          setLocalValue(value as number)
        }}
      />
    </ImageVariant>
  )
}
